import React, { useState } from "react";
import solutions1 from "../../assets/offeringsA/solutions1.png";
import solutions2 from "../../assets/offeringsA/solutions2.png";
import solutions3 from "../../assets/offeringsA/solutions3.png";
import solutions4 from "../../assets/offeringsA/solutions4.png";
import solutions5 from "../../assets/offeringsA/solutions5.png";
import functionImage from "../../assets/offeringsA/functionImage.svg";
import SolutionIllustrations from "./SolutionsIllustrations";
import GridLines from "../../assets/offeringsA/SolutionTab/grid_solution_bg.svg";
import { useScreen } from "../../context/ScreenContext";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const data = [
  {
    svg: solutions1,
    name: "Conversational AI",
    // image: image1,
    functions: [
      {
        title: "Customer & Sales Assistants",
        description:
          "Domain-trained voice and chat agents that handle inquiries, share product info, and qualify leads—without human wait time.",
      },
      {
        title: "Voice + Chat Interfaces",
        description:
          "Multilingual interfaces that plug into your contact center or app—designed for low latency and high accuracy.",
      },
      {
        title: "Training & Support Agents",
        description:
          "Simulated conversational agents that onboard, coach, and upskill employees using real-world scenarios.",
      },
    ],
  },
  {
    svg: solutions2,
    name: "Knowledge AI",
    // image: image2,
    functions: [
      {
        title: "Intelligent Content Extraction",
        description:
          "Pulls structured data, tables, and key clauses from long-form documents across formats and layouts.",
      },
      {
        title: "Workflow-Ready Outputs",
        description:
          "Automatically updates systems, triggers actions, and formats outputs—turning unstructured input into usable data.",
      },
      {
        title: "Natural Language Search",
        description:
          "Ask a question. Get the answer from your docs, wikis, and systems—instantly and contextually.",
      },
    ],
  },
  {
    svg: solutions3,
    name: "SDLC AI",
    // image: image3,
    functions: [
      {
        title: "Requirement-to-Code Agents",
        description:
          "Converts product requirements into usable boilerplate code and component suggestions.",
      },
      {
        title: "AI-Augmented Testing",
        description:
          "Auto-generates test cases and flags regressions based on changes—reducing QA cycles.",
      },
      {
        title: "Self-Healing DevOps",
        description:
          "Monitors logs, detects failures, and auto-applies known fixes to reduce downtime and alerts.",
      },
    ],
  },
  {
    svg: solutions4,
    name: "Agentic Platforms",
    // image: image4,
    functions: [
      {
        title: "Multi-Agent Workflows",
        description:
          "Multiple agents work in sync across tools and APIs—coordinating tasks with memory and reasoning.",
      },
      {
        title: "Tool-Using Agents",
        description:
          "Agents that know when and how to use your enterprise tools—like scheduling, ticketing, or BI dashboards.",
      },
      {
        title: "Context & Memory-Aware Systems",
        description:
          "Simulated agents that onboard, coach, and upskill employees using real-world scenarios.",
      },
    ],
  },
  {
    svg: solutions5,
    name: "Workforce Management",
    // image: image5,
    functions: [
      {
        title: "Recruitment Agents",
        description:
          "Screen candidates, auto-schedule interviews, and surface profile matches with minimal manual effort.",
      },
      {
        title: "Training Agents",
        description:
          "Personalized AI trainers that guide employees through modules, answer questions, and track progress.",
      },
      {
        title: "Policy Assistants",
        description:
          "Always-on HR agents that resolve employee queries on policies, leave, payroll, and compliance.",
      },
    ],
  },
];

const Solutions = () => {
  const { isMobile } = useScreen();
  const [activeIndex, setActiveIndex] = useState(0);

  const goToPrevious = () => {
    const isFirstSlide = activeIndex === 0;
    const newIndex = isFirstSlide ? data.length - 1 : activeIndex - 1;
    setActiveIndex(newIndex);
  };

  const goToNext = () => {
    const isLastSlide = activeIndex === data.length - 1;
    const newIndex = isLastSlide ? 0 : activeIndex + 1;
    setActiveIndex(newIndex);
  };

  const currentSolution = data[activeIndex];

  return (
    <div className="w-full flex flex-col justify-center items-center relative overflow-hidden pt-[36px] pb-[18px]">
      <div
        className="w-full h-full absolute -z-10 bg-cover bg-center top-[118px]"
        style={{
          backgroundImage: `url(${GridLines})`,
        }}
      />
      <div className="flex flex-col items-center justify-center md:max-w-[1440px] w-full px-[20px] md:px-[80px] lg:px-[120px] mx-auto">
        <div className="md:mx-auto w-full">
          <div className="flex flex-col items-center mb-8 lg:hidden">
            <img
              className=" w-[26px] h-[26px] rounded-[8.378px] bg-gradient-to-b from-[#68B7FF] to-[#0060C7] shadow-[0_2.094px_3.491px_0_rgba(0,0,0,0.20)]"
              src={currentSolution.svg}
              alt={currentSolution.name}
            />
            <div className="flex items-center justify-center mt-4 w-full">
              <button
                onClick={goToPrevious}
                className="p-2 focus:outline-none text-[#1E1E1E] hover:text-gray-700 transition-colors"
                aria-label="Previous solution"
              >
                <IoIosArrowBack size={20} />
              </button>

              <h2 className="text-black text-center font-montserrat text-base not-italic font-semibold leading-[12.567px] w-[160px] md:max-w-max">
                {currentSolution.name}
              </h2>

              <button
                onClick={goToNext}
                className="p-2 focus:outline-none text-[#1E1E1E] hover:text-gray-700 transition-colors"
                aria-label="Next solution"
              >
                <IoIosArrowForward size={20} />
              </button>
            </div>
          </div>
          <div className="hidden lg:flex justify-between">
            {data.map((item, index) => {
              return (
                <div
                  className={`xl:w-[240px] lg:w-1/5 h-[85px] flex-shrink-0 flex flex-col items-center gap-[20px] cursor-pointer border-b ${
                    activeIndex === index ? "border-[#000]" : "border-[#D6D6D6]"
                  } `}
                  key={index}
                  onClick={() => setActiveIndex(index)}
                >
                  <div
                    className={`h-[26px] w-[26px] rounded-[8px] bg-gradient-to-b ${
                      activeIndex === index
                        ? "from-[#68B7FF] to-[#0060C7] shadow-[0px_2px_3px_rgba(0,0,0,0.2)] "
                        : "from-[rgba(0,0,0,0.08)] to-[rgba(0,0,0,0.25)] shadow-[0px_1px_2px_rgba(0,0,0,0.1)]"
                    } flex justify-center items-center`}
                  >
                    <img src={item.svg} alt={item.name} />
                  </div>
                  <p
                    className={`py-[2px] text-center ${
                      activeIndex === index
                        ? "text-black font-semibold"
                        : "font-medium bg-clip-text text-transparent bg-gradient-to-b from-[rgba(0,0,0,0.2)] to-[rgba(0,0,0,0.35)]"
                    } text-[16px] leading-[13px] not-italic font-montserrat`}
                  >
                    {item.name}
                  </p>
                </div>
              );
            })}
          </div>
          <div>
            {/* <div className="flex flex-col items-center justify-center dotted-grid-bg h-[582px] w-[1200px] absolute -z-10"></div> */}
            <div className="relative flex lg:flex-row flex-col gap-[36px] justify-center items-start w-full py-[60px]">
              <div className="h-[150px] sm:h-[200px] lg:h-[370px] flex-shrink-0 md:mt-[80px] md:mb-[60px] flex justify-center items-start lg:w-1/2 w-full">
                <SolutionIllustrations activeIndex={activeIndex} />
              </div>
              <div className="flex flex-col gap-[16px] md:gap-[36px] w-full lg:max-w-max">
                {data[activeIndex].functions.map((func, idx) => {
                  return (
                    <div
                      className="flex w-full flex-col items-start gap-[15px] p-[16px] rounded-[4px] md:rounded-0 border-[0.5px] border-[#A6A6A6] md:border-0 bg-white md:shadow-[inset_0px_0px_0px_1.171px_#E1E5EB,0px_1.171px_3.514px_0px_rgba(31,34,41,0.08)]"
                      key={idx}
                    >
                      <div className="flex gap-4 items-center justify-center">
                        <img
                          src={functionImage}
                          className="w-[27px] h-[27px]"
                        />
                        <p className="text-[#263238] font-normal md:font-medium text-base md:text-[24px] leading-normal md:leading-[23px] not-italic font-montserrat">
                          {func.title}
                        </p>
                      </div>
                      <p className="text-[#263238] font-light text-[16px] leading-[25px] not-italic font-roboto hidden md:block">
                        {func.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
